<template>
  <div class="login_as">
    <div class="title">{{ errorMessage || text("wallet.auth.login.login") }}</div>
    <BaseButton v-if="errorMessage" @click="goLogin">
      <template #label>
        {{ text("wallet.auth.login.login") }}
      </template>
    </BaseButton>
  </div>
</template>

<script>
import BaseButton from "@/components/base/buttons/BaseButton.vue"

export default {
  name: "LoginAs",
  components: {
    BaseButton,
  },
  data() {
    return {
      errorMessage: "",
    }
  },
  async mounted() {
    const token = this.$route.query.token

    if (!token) {
      this.errorMessage = "Login as token is missing"
      return
    }

    this.$store.commit("setAuthToken", token)
    await this.$store.dispatch("refreshAuthInfo")

    if (!this.$store.state.authInfo) {
      this.errorMessage = "Login as token is invalid or expired"
      return
    }

    this.$router.replace({ name: "Home" })
  },
  methods: {
    goLogin() {
      this.$router.push({ name: "LogIn" })
    },
  },
}
</script>

<style lang="scss" scoped>
.login_as {
  width: 100%;
  max-width: 335px;
  margin-top: 32px;
  display: flex;
  flex-direction: column;
  align-items: stretch;

  .title {
    margin-bottom: 24px;
    color: var(--text-color-primary);
    text-align: center;
    font-family: "Rubik", sans-serif;
    font-size: 20px;
    font-weight: 700;
    line-height: 135%;
  }
}
</style>
